import getCharts from '../getCharts'
import { BoardCRUD } from '../../constants/api.config'
 
export default async function SaveBoard(params = {}, boardData = null, boardID = null) {
    let mode = params

    if (params && typeof params === 'object' && !Array.isArray(params)) {
        mode = params.mode
        boardData = params.boardData ?? params.boarddata ?? boardData
        boardID = params.boardID ?? params.BoardID ?? params.boardId ?? params.BoardId ?? params.boardid ?? boardID
    }

    if (boardData && typeof boardData !== 'string') {
        try {
            boardData = JSON.stringify(boardData)
        } catch (err) {
            console.error('BoardCrud API failed to serialize boardData:', err)
        }
    }

    const payload = {
        mode,
        boardData,
        boardID
    }

   
    try {
        const res = await getCharts(BoardCRUD, payload)
        return res.data
    } catch (error) {
        return error
    }
}
 